import { RolesType } from 'api/api';

export type AuthPageRequirement = {
	minRole?: RolesType;
	exactRoles?: RolesType[];
	isPartnerArea?: boolean;
    blockIfNoSubscription?: boolean;
}

const basicUserRequirements: AuthPageRequirement = { minRole: RolesType.BasicUser };

export const profilePageAuthRequirements: AuthPageRequirement = {
	minRole: RolesType.NoUnits,
};
export const administrationPageAuthRequirements: AuthPageRequirement = {
	minRole: RolesType.Admin,
};
export const unitsPageAuthRequirements: AuthPageRequirement = basicUserRequirements;
export const locationPageAuthRequirements: AuthPageRequirement = basicUserRequirements;
export const reportPageAuthRequirements: AuthPageRequirement = basicUserRequirements;
export const notificationPageAuthRequirements: AuthPageRequirement = basicUserRequirements;

export const unitHistoryAuthRequirements: AuthPageRequirement = {
    blockIfNoSubscription: true,
    minRole: RolesType.BasicUser
}
